<div class="license-viewer-container" [class.light-terminal]="!isDarkMode">

  <!-- Search Section -->
  <div class="search-section">
    <div class="search-container">
      <div class="search-input-wrapper">
        <span class="bi bi-search search-icon"></span>
        <input type="text"
               class="search-input"
               [(ngModel)]="searchTerm"
               (input)="onSearch()"
               (keydown.enter)="nextMatch()"
               (keydown.escape)="clearSearch()"
               [placeholder]="searchPlaceholder"
               autocomplete="off">

        <!-- Navigation buttons for search results -->
        <div class="search-navigation" *ngIf="searchTerm">
          <button class="nav-btn"
                  (click)="previousMatch()"
                  [disabled]="totalMatches === 0"
                  title="Previous match (Shift+Enter)">
            <span class="bi bi-chevron-up"></span>
          </button>
          <button class="nav-btn"
                  (click)="nextMatch()"
                  [disabled]="totalMatches === 0"
                  title="Next match (Enter)">
            <span class="bi bi-chevron-down"></span>
          </button>
        </div>

        <button *ngIf="searchTerm"
                class="clear-search-btn"
                (click)="clearSearch()"
                title="Clear Search (Esc)">
          <span class="bi bi-x"></span>
        </button>
      </div>

      <div class="search-info-and-actions">
        <div class="search-info">
          <span class="line-count">{{ getLineCount() }} lines</span>
          <span *ngIf="searchTerm && totalMatches > 0" class="search-results">
            {{ currentMatchIndex }} of {{ totalMatches }}
          </span>
          <span *ngIf="searchTerm && totalMatches === 0" class="no-matches">
            No matches
          </span>
        </div>

        <!-- Moved Header Actions -->
        <div class="header-actions">
          <!-- Line Numbers Toggle -->
          <button class="action-btn"
                  (click)="toggleLineNumbers()"
                  [title]="lineNumbers ? 'Hide Line Numbers' : 'Show Line Numbers'">
            <span [class]="lineNumbers ? 'bi bi-list-ol' : 'bi bi-list'"></span>
          </button>

          <!-- Copy Button -->
          <button class="action-btn"
                  [class.copy-success]="copySuccess"
                  (click)="copyToClipboard()"
                  title="Copy to Clipboard">
            <span [class]="copySuccess ? 'bi bi-clipboard2-check-fill' : 'bi bi-clipboard2-check'"
                  [class.bounce-in]="copySuccess"></span>
          </button>

          <!-- Download Button -->
          <button class="action-btn"
                  (click)="downloadData()"
                  title="Download as Text File"
                  [disabled]="isLoading">
            <span class="bi bi-download"
                  [class.bounce-in]="downloadTriggered"></span>
          </button>

          <!-- Refresh Button -->
          <button class="action-btn"
                  (click)="refreshData()"
                  title="Refresh Data"
                  [disabled]="isLoading">
            <span class="bi bi-arrow-clockwise" [class.spinning]="isLoading"></span>
          </button>

          <!-- Theme Toggle -->
          <button class="action-btn theme-toggle"
                  (click)="toggleTheme()"
                  [title]="isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
            <span [class]="isDarkMode ? 'bi bi-brightness-high-fill' : 'bi bi-moon'"></span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Content Section -->
  <div class="content-section">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading license data...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !isLoading" class="error-container">
      <div class="error-icon">⚠️</div>
      <h3 class="error-title">Error Loading Data</h3>
      <p class="error-message">{{ error }}</p>
      <button class="retry-btn" (click)="refreshData()">
        <span class="bi bi-arrow-clockwise"></span>
        Try Again
      </button>
    </div>

    <!-- Data Display -->
    <div *ngIf="!isLoading && !error" class="data-container">

      <!-- Empty State -->
      <div *ngIf="!licenseData" class="empty-state">
        <div class="empty-icon">📄</div>
        <h3 class="empty-title">No Data Available</h3>
        <p class="empty-message">No license data found for this deployment.</p>
      </div>

      <!-- No Search Results -->
      <div *ngIf="licenseData && searchTerm && totalMatches === 0" class="no-results">
        <div class="no-results-icon">🔍</div>
        <h3 class="no-results-title">No Results Found</h3>
        <p class="no-results-message">
          No results found for "{{ searchTerm }}". Try a different search term.
        </p>
        <button class="clear-search-btn-alt" (click)="clearSearch()">
          Clear Search
        </button>
      </div>

      <!-- License Data Display -->
      <div *ngIf="displayData" class="data-display">
        <pre class="terminal-content" [innerHTML]="getFormattedData()"></pre>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="viewer-footer" *ngIf="!isLoading && !error && licenseData">
    <div class="footer-info">
      <span class="data-size">{{ licenseData.length }} characters</span>
      <!--<span class="last-updated">Last updated: {{ new Date().toLocaleString() }}</span>-->
    </div>
  </div>

  <!-- Toast Notification -->
  <div class="toast-notification" [class.show]="showToast" (click)="hideToast()">
    <span class="toast-message">{{ toastMessage }}</span>
    <button class="toast-close" (click)="hideToast()">×</button>
  </div>

</div>
